import { Link } from '@tanstack/react-router';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useCurrentRole } from '../auth/useCurrentRole';

export function SettingsPage() {
  const role = useCurrentRole();

  if (!role.isAuthReady) {
    return <p className="text-brand-slate">Loading…</p>;
  }

  if (!role.isSignedIn) {
    return (
      <Card className="max-w-xl">
        <CardHeader>
          <CardTitle>Not signed in</CardTitle>
          <CardDescription>
            Go back to{' '}
            <Link to="/" className="text-brand-royal underline-offset-4 hover:underline">
              home
            </Link>{' '}
            to sign in.
          </CardDescription>
        </CardHeader>
      </Card>
    );
  }

  const userType = role.isPractitioner ? 'practitioner' : role.isCustomer ? 'customer' : 'unknown';

  return (
    <Card className="max-w-2xl">
      <CardHeader>
        <CardTitle>Settings</CardTitle>
        <CardDescription>Your identity as it appears to the app.</CardDescription>
      </CardHeader>
      <CardContent>
        <dl className="grid grid-cols-[max-content_1fr] gap-x-6 gap-y-2 text-sm">
          <dt className="text-brand-slate">clerk user id</dt>
          <dd className="font-mono break-all">{role.userKey ?? '—'}</dd>
          <dt className="text-brand-slate">email</dt>
          <dd className="font-mono">{role.email ?? '—'}</dd>
          <dt className="text-brand-slate">user type</dt>
          <dd className="font-mono">{userType}</dd>
          <dt className="text-brand-slate">org id</dt>
          <dd className="font-mono break-all">
            {role.orgId ?? <span className="text-brand-slate">— (practitioner)</span>}
          </dd>
        </dl>
      </CardContent>
    </Card>
  );
}
